<template lang="">
  <div>
    <LaudoTranslucenciaNucal></LaudoTranslucenciaNucal>
  </div>
</template>
<script>
import LaudoTranslucenciaNucal from "../components/laudos/formularios/exames/translucenciaNucal/LaudoTranslucenciaNucal.vue";
export default {
  components: {
    LaudoTranslucenciaNucal,
  },
};
</script>
<style lang=""></style>
